//3rd march js
//js for set qty according variant

document.addEventListener("DOMContentLoaded", function () {
    const shopButtons = document.querySelectorAll('.shop-btn1');
    console.log(`Found ${shopButtons.length} shop buttons`);

    shopButtons.forEach(button => {
        button.addEventListener('click', function () {
            console.log("✅ Shop button clicked");

            const form = this.closest('.form');
            if (!form) {
                console.log("❌ Form with class 'form' not found");
                return;
            }
            console.log("✅ Form found:", form);

            const variantIdInput = form.querySelector('.product-variant-id');
            const variantId = variantIdInput ? variantIdInput.value : null;
            console.log("Variant ID:", variantId || "❌ Not found");

            const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
            const originalSellingPlan = sellingPlanInput ? sellingPlanInput.value : null; // Store original value
            let sellingPlan = originalSellingPlan; // This will be modified if needed
            console.log("Selling Plan (original):", originalSellingPlan || "❌ Not found");

            const toggleCheckbox = document.getElementById('toggleCheckbox');
            const isNonePrice = toggleCheckbox && toggleCheckbox.classList.contains('show_noneprice');
            if (isNonePrice && sellingPlanInput) {
                sellingPlan = ""; // "Remove" selling plan in logic
                sellingPlanInput.value = ""; // Update the form field to blank
                console.log("✅ 'show_noneprice' detected, sellingPlan set to blank in form");
            }
            console.log("Show noneprice active:", isNonePrice);

            const qtyInput = form.querySelector("#c_qty");
            console.log("Quantity Input:", qtyInput || "❌ Not found");

            if (!variantId || !qtyInput) {
                console.log("❌ Missing required fields: variantId or qtyInput");
                return;
            }

            const qtyMapping = {
                "49024256508097": { "3268608193": 1, "3268542657": 2, "3268575425": 3 },
                "49024256540865": { "3268608193": 2, "3268542657": 4, "3268575425": 6 },
                "49024256573633": { "3268608193": 3, "3268542657": 6, "3268575425": 9 },
                "49024256606401": { "3268608193": 4, "3268542657": 8, "3268575425": 12 }
            };

            if (qtyMapping[variantId]) {
                if (isNonePrice && originalSellingPlan && qtyMapping[variantId][originalSellingPlan]) {
                    qtyInput.value = qtyMapping[variantId][originalSellingPlan];
                    console.log("✅ show_noneprice active, using original selling plan quantity:", qtyInput.value);
                } else if (sellingPlan && qtyMapping[variantId][sellingPlan]) {
                    qtyInput.value = qtyMapping[variantId][sellingPlan];
                    console.log("✅ Updated quantity:", qtyInput.value);
                } else {
                    qtyInput.value = "";
                    console.log("❌ No valid selling plan mapping, quantity set to empty");
                }
            } else {
                qtyInput.value = "";
                console.log("❌ No matching variantId in qtyMapping, quantity set to empty");
            }
        });
    });
});



//subscribe js

$(document).ready(function(){
$('.sub-tog-text h3').addClass('subscribe_text');
    $('#toggleCheckbox').on('change', function() {

        if($(this).is(':checked')) {
            $('.loop-widget-purchase-option-onetime').removeClass('show');  
            $('#toggleCheckbox').removeClass('show_noneprice');
            $('.d_none').removeClass('show');
            $('.loop-widget-purchase-option').show(); 
$('.otherhalf-right-section').removeClass('price_of_noneprice');
 $('.loop-widget-purchase-option-selected').trigger('click');
$('.shop-btn1').removeClass('cart_btn_text');
$('.sub-tog-text h3').addClass('subscribe_text');
//js for update price
        } else {
            $('.loop-widget-purchase-option-onetime').addClass('show');  
            $('.d_none').addClass('show');   
            $('#toggleCheckbox').addClass('show_noneprice');
            $('.otherhalf-right-section').addClass('price_of_noneprice');
   $('.loop-widget-purchase-option-selected').trigger('click');
$('.shop-btn1').addClass('cart_btn_text');
//$('.sub-tog-text h3').removeClass('subscribe_text');

        }
    });
});


//price change in loop widget

$(document).ready(function () {
    // Price mappings
    const regularPriceMap = {
        "Small": ["$35.19", "$67.98", "$98.37"],
        "Medium": ["$70.38", "$135.96", "$196.74"],
        "Large": ["$105.57", "$203.94", "$295.11"],
        "XL": ["$140.76", "$271.92", "$393.48"]
    };

    const nonePriceMap = {
        "Small": ["$39.99", "$79.98", "$119.97"],
        "Medium": ["$79.98", "$159.96", "$239.94"],
        "Large": ["$119.97", "$239.94", "$359.91"],
        "XL": ["$159.96", "$319.92", "$479.88"]
    };

    const discountLabels = [" (12% OFF)", " (15% OFF)", " (18% OFF)"];
    const baseLabels = ["2-Month Plan", "4-Month Plan", "6-Month Plan"];
    let observer;
    const MAX_RETRIES = 10;

    // Determine which price map to use
    function getPriceMap(selectedSize) {
        const $container = $('.otherhalf-right-section');
        const useNonePrice = $container.hasClass('price_of_noneprice');
        console.log(`Price map selected: ${useNonePrice ? 'nonePriceMap' : 'regularPriceMap'}`);
        return useNonePrice ? nonePriceMap : regularPriceMap;
    }

    // Update prices, labels, and subscribe text
    function updatePrices(selectedSize, retryCount = 0) {
        const priceMap = getPriceMap(selectedSize);
        const isRegularPrice = (priceMap === regularPriceMap);
        
        if (!priceMap[selectedSize]) {
            console.error(`No prices found for size: ${selectedSize}`);
            return;
        }

        const $priceElements = $(".loop-widget-purchase-option-price:not(.new_price)");
        const $labelElements = $(".loop-widget-purchase-option-label");
        const $subscribeText = $(".subscribe_text");

        // Require only price and label elements, make subscribe_text optional
        if ($priceElements.length < 3 || $labelElements.length < 3) {
            if (retryCount < MAX_RETRIES) {
                console.warn(`Required elements not fully loaded (Retry ${retryCount + 1}/${MAX_RETRIES}), retrying in 500ms...`);
                console.log(`Elements status - Prices: ${$priceElements.length}, Labels: ${$labelElements.length}, Subscribe Text: ${$subscribeText.length}`);
                setTimeout(() => updatePrices(selectedSize, retryCount + 1), 500);
            } else {
                console.error(`Failed to load required elements (prices or labels) after ${MAX_RETRIES} retries. Aborting.`);
            }
            return;
        }

        if (observer) observer.disconnect();

        $(".new_price").remove();

        const prices = priceMap[selectedSize];
        let selectedIndex = -1;

        // Update prices and labels, and find the selected plan
        $priceElements.each(function (index) {
            if (index < 3) {
                const priceText = prices[index];
                const labelText = isRegularPrice ? baseLabels[index] + discountLabels[index] : baseLabels[index];
                $labelElements.eq(index).text(labelText);
                $('<div></div>').addClass("new_price").text(priceText).insertAfter(this);

                // Check if this is the selected option
                const $option = $(this).closest('.loop-widget-purchase-option');
                if ($option.hasClass('loop-widget-purchase-option-selected')) {
                    selectedIndex = index;
                    console.log(`Selected plan index: ${selectedIndex}, Label: ${labelText}`);
                }
            }
        });

        // Update subscribe text if it exists
        if ($subscribeText.length) {
            if (selectedIndex !== -1) {
                if (isRegularPrice) {
                    $subscribeText.text(`Subscribe and Save${discountLabels[selectedIndex]}`);
                    console.log(`Updated subscribe_text to: Subscribe and Save${discountLabels[selectedIndex]}`);
                } else {
                    $subscribeText.text("Subscribe and Save");
                    console.log("Updated subscribe_text to: Subscribe and Save (nonePriceMap)");
                }
            } else {
                console.warn("No selected plan found, setting default subscribe text!");
                $subscribeText.text("Subscribe and Save");
            }
        } else {
            console.warn("No .subscribe_text element found in DOM, skipping subscribe text update.");
        }

        // Update .shop-btn1.cart_btn_text based on price map
        $('.shop-btn1.cart_btn_text').each(function () {
            const $newShopText = $(this).find('.new_shoptext');
            if (isRegularPrice) {
                if ($newShopText.length) {
                    $newShopText.remove();
                    console.log("✅ Removed <span class='new_shoptext'> from .shop-btn1 (regularPriceMap)");
                }
            } else {
                if (!$newShopText.length) {
                    const $newSpan = $('<span></span>')
                        .addClass('new_shoptext')
                        .text('Add to cart');
                    $(this).append($newSpan);
                    console.log("✅ Inserted new <span class='new_shoptext'> into .shop-btn1 (nonePriceMap)");
                }
            }
        });

        const $newPrices = $(".new_price");
        if ($newPrices.length < 3) {
            console.warn("New prices not fully rendered, retrying in 500ms...");
            setTimeout(() => updatePrices(selectedSize), 500);
        }

        if (observer) {
            const $target = $("body");
            observer.observe($target[0], { childList: true, subtree: true });
        }
    }

    // Debounce utility
    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    // Initialize
    function initialize() {
        const $dogSizeBox = $(".dog-size-box");
        if ($dogSizeBox.length === 0) {
            console.error("Error: '.dog-size-box' container not found!");
            return;
        }

        const $initialChecked = $dogSizeBox.find("input[type='radio']:checked");
        if ($initialChecked.length) {
            console.log(`Initializing with size: ${$initialChecked.val()}`);
            updatePrices($initialChecked.val());
        } else {
            console.warn("No initial size selected!");
        }

        $(document).off("change", ".dog-size-box input[type='radio']");
        $(document).on("change", ".dog-size-box input[type='radio']", function () {
            console.log(`Size changed to: ${$(this).val()}`);
            updatePrices($(this).val());
        });

        // Handle plan selection change
        $(document).off("click", ".loop-widget-purchase-option");
        $(document).on("click", ".loop-widget-purchase-option", function () {
            console.log("Plan selection clicked!");
            setTimeout(() => {
                const $checkedRadio = $(".dog-size-box input[type='radio']:checked");
                if ($checkedRadio.length) {
                    updatePrices($checkedRadio.val());
                }
            }, 200);
        });
    }

    setTimeout(initialize, 1000);

    // MutationObserver to handle dynamic DOM changes
    observer = new MutationObserver(debounce(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes.length || mutation.removedNodes.length) {
                const $checkedRadio = $(".dog-size-box input[type='radio']:checked");
                if ($checkedRadio.length) {
                    updatePrices($checkedRadio.val());
                }
            }
        });
    }, 500));

    const $target = $("body");
    observer.observe($target[0], { childList: true, subtree: true });
});